export default "__VITE_ASSET__CsYTgUH$__"